import { BaseAccountContract } from '../accounts/types';
import { UserContract } from '../../../global/store/authentication/types';

export enum TaskPriority {
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high',
}

export enum TaskStatus {
  OPEN = 'open',
  CLOSED = 'closed',
}

export type TaskScope = 'mine' | 'assigned';
export type TaskStatusFilter = 'open' | 'all';

export interface TaskContract {
  id: string;
  account: BaseAccountContract;
  assigner: UserContract;
  assignee: UserContract;
  title: string;
  description?: string;
  dueDate?: string;
  priority: TaskPriority;
  status: TaskStatus;
  closedOn?: string;
  activityId?: string;
  createdOn: string;
}

export interface CreateTaskContract {
  accountId: string;
  assigneeId: string;
  title: string;
  description?: string;
  dueDate?: string;
  priority?: TaskPriority;
  activityId?: string;
}

export interface FollowUpTaskContract {
  assigneeId: string;
  title: string;
  description?: string;
  dueDate?: string;
  priority?: TaskPriority;
}

export interface UpdateTaskContract {
  title?: string;
  description?: string | null;
  dueDate?: string | null;
  priority?: TaskPriority;
  status?: TaskStatus;
  assigneeId?: string;
}

export interface TaskCountsContract {
  myOpen: number;
  assignedOpen: number;
  totalOpen: number;
  totalClosed: number;
}
